<template>
    <div class="cerBg">

        <div class="topBar" id="topbar1">
        <img class="topLogo" src="/img/palma/logo_palma.png" alt="" />
        </div>    

        <div class="container">
            <div class="title section-title">
                <p>Download Certificate</p>
            </div>
            <div class="cerLogo">
              <img src="img/palma/shell.png" />
            </div>

            <div class="cerText fs16">
                <p>
                    Thank you for attending the MIS Global Conference! Please fill in you email address for authentication:
                </p>
            </div>  

            <div class="cerInput">
                <input type="email" v-model="userEmail" placeholder="Enter your email address..." />
            </div>

            <div class="xrBtn">
                <div class="base_btn reg_btn cerBtn" target="_blank" @click="downloadCer">                   
                  <span class="title">Download</span>
                  <i class="fal fa-chevron-down pl-s"></i>
                </div>
            </div>

        </div>
    </div>
</template>
<style>    
    .cerBg
    {
        background-color: #1778bb !important;
        width: 100%;
        min-height: 100vh;
        display: flex;
        align-content: center;
        align-items: center;
    }
    .cerBg .container
    {
      max-width: 1100px;
      width: 60vw;
    }
    .cerBg .title
    {
        color: #fff;
    }
    .cerLogo
    {
      text-align: center;      
      height:auto;      
      margin: auto;
      width: 100%;
    }
    .cerText
    {
        width: 30vw;
        color: #fff;
        text-align: center;
        margin: auto;
    }
    .cerLogo img
    {
        margin: auto;
        width: 20vw;
        margin: auto;
        max-width: 700px;   
    }
    .cerBtn
    {
        opacity: 1;
    }

    .cerInput
    {
        padding-top: 40px;
    }
    .cerInput input
    {
        position: relative;
        padding: 25px 25px;
        border-radius: 40px;
        height: 40px;
        font-size: 16px;        
        background-color: transparent;
        border: solid 2px #fff;
        color: #fff;
        width: 35vw;
        max-width: 350px;
    }
    .cerInput input::placeholder
    {
        color: #fff;
        font-style: italic;
        font-size: 12px;
    }
    .cerInput input:focus {
            outline: none;
    }


  @media (max-width: 850px) { 
    .cerBg
    {
        width: 100%;
        display: block;
    }
    .cerBg .container
    {
      width: 100vw;
      max-width: 100vw;
      padding: 8vw;
    }
    .cerLogo img
    {
        margin: auto;
        width: 60vw;
        margin: auto;
    }    
    .cerInput input
    {
        width: 80vw;
        max-width: 80vw;
    }
    .section-title
    {
        font-size: 32px !important;
        font-weight: 300 !important;
    }
    .cerText
    {
        width: 100%;
        max-width: 70vw;
    }

    }
</style>




<script>

export default {
    data()
    {
        return{
            userEmail:''
        }
    },
    methods:
    {
        downloadCer()
        {
            if(this.userEmail.length>0)
            {
                this.verifyMail();
            }
        },
        verifyMail()
        {
            var vm = this;
            //check if the email is valid 
            var isEmailValid = false;
            //let checkURL = 'https://360.mis-implants.com/api/verifyemail.ashx?email='+this.userEmail;
            let checkURL = 'https://api.mis-implants.com/api/addCerPdf?email='+this.userEmail+'&verify=true';
            fetch(checkURL)
            .then(function(response) 
            {
                response.text().then(function(responseString) { 
                    //alert("responseString="+responseString.length);
                    
                    if(responseString.indexOf('True')>-1){
                        document.location = 'https://360.mis-implants.com/download.aspx?email='+vm.userEmail;
                    }else{
                        alert("Please provide the email address you used to register for the conference.");
                    }

                });
            }).catch(function() {
                console.log("error");
            });


            //if valid:
            //carlosesmack@gmail.com
            
        }
    },
  computed: {
  }
};
</script>
